<script setup lang="ts">
const props = defineProps<{
  region: LayoutRegion;
}>();
const { layoutRegionRef, layoutRegionBinds } = useLayoutRegion(() => props.region);
</script>

<template>
  <client-only>
    <teleport v-if="layoutRegionRef" :to="layoutRegionRef">
      <slot :layout-region-binds />
    </teleport>
  </client-only>
</template>
